import { useUser, useUserSettings } from "@/composables/user";
import { isRouteAccountSetup } from "@/router/helpers";
import { createAccountSetupLink } from "@/router/linkFactories";
import { checkUserOnInitialPageLoad } from "@/services/user/auth/login";
import { type NavigationGuardNext, type RouteLocationNormalized } from "vue-router";

export const handleAccountSetupRequired = async (route: RouteLocationNormalized, _: RouteLocationNormalized, next: NavigationGuardNext) => {
  if (isRouteAccountSetup(route)) {
    return next();
  }

  await checkUserOnInitialPageLoad();
  const { userSettings } = useUserSettings();
  const { isUserLoggedIn } = useUser();

  const isAccountCompletitionNeeded = isUserLoggedIn.value && userSettings.value === undefined;
  if (isAccountCompletitionNeeded) {
    return next(createAccountSetupLink());
  } else {
    return next();
  }
};
